import { onDocumentReady } from '@theme/utilities';

const SWIPE_CLASS = 'product-swipe';
const VISIBLE_CLASS = 'product-swipe--visible';
const ANIMATION_DELAY_STEP = 120;
const OBSERVER_OPTIONS = { threshold: 0.2 };
const EXIT_DELAY = 3000;

function revealItem(entry) {
  const target = entry.target;
  if (entry.isIntersecting) {
    target.classList.add(VISIBLE_CLASS);

    if (target.__productSwipeExitTimer) {
      clearTimeout(target.__productSwipeExitTimer);
      delete target.__productSwipeExitTimer;
    }
    return;
  }

  if (target.classList.contains(VISIBLE_CLASS) && !target.__productSwipeExitTimer) {
    target.__productSwipeExitTimer = setTimeout(() => {
      target.classList.remove(VISIBLE_CLASS);
      delete target.__productSwipeExitTimer;
    }, EXIT_DELAY);
  }
}

function initializeAnimation() {
  if (window.__productGridSwipeInitialized) {
    return;
  }

  window.__productGridSwipeInitialized = true;

  const resourceLists = document.querySelectorAll('.resource-list--grid');
  if (!resourceLists.length) {
    return;
  }

  const items = [];

  resourceLists.forEach((list) => {
    const listItems = Array.from(list.querySelectorAll('.resource-list__item'));
    if (listItems.length) {
      items.push(...listItems);
    }
  });

  if (!items.length) {
    return;
  }

  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => revealItem(entry));
  }, OBSERVER_OPTIONS) : null;

  items.forEach((item, index) => {
    item.classList.add(SWIPE_CLASS);
    item.style.setProperty('--product-card-delay', `${index * ANIMATION_DELAY_STEP}ms`);

    if (observer) {
      observer.observe(item);
    } else {
      item.classList.add(VISIBLE_CLASS);
    }
  });
}

onDocumentReady(initializeAnimation);
